import { call, delay, put, select, takeEvery } from 'redux-saga/effects';
import * as getProfileInfoActions from '../../actions/profile/profileActions';
// import * as loginActions from '../../../../Authorization/redux/actions/RestoreLogin';
import { authUpdateProfileInfo } from '../../../../Authorization/redux/actions/GetUser/getUserActions';
import history from '../../../../../common/history';
import { getProfileInfoRequest } from '../../../api/profile';
import { updateProfileRequest } from '../../../api/profile/updateProfileRequest';
import showSuccessWindow from '../../../../../common/components/successPopup/successPopup';
import { successProfileUpdation } from '../../../components/MyProfile/success';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import { dataAdjustmentErrorResponse } from '../../../../Employees/api/profileCard/dataAdjustment';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};

function* getProfileInfoSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getProfileInfoRequest, activeProfileId);
      yield put(getProfileInfoActions.getProfileInfoSuccess(response));
    } catch (e) {
      yield put(getProfileInfoActions.getProfileInfoFailure);
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(getProfileInfoActions.getProfileInfo(activeProfileId))
      : history.push('/authorization/profiles');
  }
}

function* updateProfileSaga(action) {
  let userId = yield select(getUserId);
  let activeProfileId = yield select(getActiveProfileId);

  if (userId && activeProfileId) {
    try {
      const response = yield call(
        updateProfileRequest,
        userId,
        activeProfileId,
        action.payload
      );
      yield put(getProfileInfoActions.updateProfileInfoSuccess(response));
      yield put(authUpdateProfileInfo(response));
      showSuccessWindow(
        successProfileUpdation(
          `${response.lastname ? response.lastname : ''} ${
            response.name ? response.name[0] + '. ' : ''
          }${response.patronymic ? response.patronymic[0] + '.' : ''}`
        )
      );
      // loginActions.restoreLogin();
      //if (response.status === 200) {
      //
      // loginActions.restoreLogin();
      // history.push('/authorization/profiles');
      //}
    } catch (e) {
      let errData = errorProcessing(e, dataAdjustmentErrorResponse);
      yield put(getProfileInfoActions.updateProfileInfoFailure(errData));
    }
  } else {
    yield delay(500);
    userId = yield select(getUserId);
    userId
      ? yield put(getProfileInfoActions.updateProfileInfo(userId))
      : history.push('/authorization/profiles');
  }
}

export function* getProfileInfoWatcher() {
  yield takeEvery(
    getProfileInfoActions.getProfileInfo.toString(),
    getProfileInfoSaga
  );
  yield takeEvery(
    getProfileInfoActions.updateProfileInfo.toString(),
    updateProfileSaga
  );
}
